import styled from 'styled-components'
import { COLORS } from 'constants/colors'

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${props => (props.noMargin ? '0' : '16px')};
  ${props =>
    props.historic &&
    `
    height:100%;
    margin:0;
    border:0;
    outline:0;
  `}
`
export const Label = styled.label`
  color: ${props => (props.white ? COLORS.white : COLORS.gray45)};
  font-size: 10px;
  line-height: 10px;
  min-height: 10px;
  margin-bottom: 5px;
  text-transform: uppercase;
`

export const Error = styled.span`
  color: ${COLORS.rustyRed};
  line-height: 16px;
  min-height: 16px;
  font-size: 14px;
  margin-left: 3px;
`
